import React  from 'react';


export const Notification = () => {



    
    

    return (
        <div className="notification_bar" >
               
    
        </div>
    );
};
